// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".left img[data-v-47348ef4]{margin-left:10px;width:40px}.right h4[data-v-47348ef4]{margin:15px 0 5px}.right p[data-v-47348ef4]{font-size:14px;margin:5px 0 15px}[data-v-47348ef4]:export{green:#1989fa;white:#fff}", ""]);
// Exports
module.exports = exports;
